import { useState, useEffect } from "react";
import { Menu, Sidebar, MenuItem } from "react-pro-sidebar";
import { useProSidebar } from "react-pro-sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import logo from '../assets/img/codeflare-app.webp';
import html from '../assets/img/html.png';
import user from '../assets/img/user.png';
import { useSidebarContext } from "./SidebarCourseContext";
import Greet  from '../components/GreetUser';
import { Link } from "react-router-dom";
import { tokens } from "../theme";
import { useTheme, Box, Typography, IconButton } from "@mui/material";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import MarkUnreadChatAltOutlinedIcon from "@mui/icons-material/MarkUnreadChatAltOutlined";
import LocalLibraryOutlinedIcon from "@mui/icons-material/LocalLibraryOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import CardMembershipOutlinedIcon from "@mui/icons-material/CardMembershipOutlined";
import LoyaltyOutlinedIcon from "@mui/icons-material/LoyaltyOutlined";
import AccountBoxOutlinedIcon from "@mui/icons-material/AccountBoxOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SwitchRightOutlinedIcon from "@mui/icons-material/SwitchRightOutlined";
import SwitchLeftOutlinedIcon from "@mui/icons-material/SwitchLeftOutlined";

const HTMLCourseNav = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const navigate = useNavigate();
  const [activePath, setActivePath] = useState("");
  const { sidebarRTL, setSidebarRTL, sidebarImage } = useSidebarContext();
  const { collapseSidebar, toggleSidebar, collapsed, broken } = useProSidebar();

  // Update active path when location changes
  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  // Check if a menu item is active
  const isActive = (path) => {
    return activePath.includes(path);
  };

  // Get active style for menu items
  const getActiveStyle = (path) => {
    return isActive(path) ? {
      backgroundColor: colors.blueAccent[500],
      color: colors.white[100],
      borderRadius: '8px',
      margin: '4px 8px',
      '&:hover': {
        backgroundColor: colors.blueAccent[600],
      }
    } : {
      backgroundColor: 'transparent',
      color: colors.white[100],
      margin: '4px 8px',
      '&:hover': {
        backgroundColor: colors.blueAccent[800],
        borderRadius: '8px',
      }
    };
  };

  // Handle menu item click
  const handleMenuItemClick = (path) => {
    navigate(path);
  };

  return (
    <Box
      sx={{
        position: "sticky",
        display: "flex",
        height: "100vh",
        top: 0,
        bottom: 0,
        zIndex: 10000,
        "& .sidebar": {
          border: "none",
        },
        "& .menu-icon": {
          backgroundColor: "transparent !important",
        },
        "& .menu-item": {
          padding: "8px 20px 8px 20px !important",
          backgroundColor: "transparent !important",
          transition: "all 0.3s ease",
          cursor: "pointer",
        },
        "& .menu-anchor": {
          color: "inherit !important",
          backgroundColor: "transparent !important",
        },
        "& .menu-item:hover": {
          backgroundColor: `${colors.blueAccent[800]} !important`,
          borderRadius: '8px',
        },
        "& .menu-item.active": {
          backgroundColor: `${colors.blueAccent[500]} !important`,
          color: `${colors.white[100]} !important`,
          borderRadius: '8px',
        },
      }}
    >
      <Sidebar
        breakPoint="md"
        rtl={sidebarRTL}
        backgroundColor={colors.primary[200]}
        image={sidebarImage}
      >
        <Menu iconshape="square">
          <MenuItem
            icon={
              collapsed ? (
                <MenuOutlinedIcon onClick={() => collapseSidebar()} />
              ) : sidebarRTL ? (
                <SwitchLeftOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              ) : (
                <SwitchRightOutlinedIcon
                  onClick={() => setSidebarRTL(!sidebarRTL)}
                />
              )
            }
            style={{
              margin: "10px 0 20px 0",
              color: colors.blueAccent[100],
            }}
          >
            {!collapsed && (
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                ml="15px"
              >
              <img
                className="avater-image"
                alt="Codefussion"
                width="30%"
                height="auto"
                src={logo}
                style={{ cursor: "pointer", alignSelf: 'center' }}
              />
                <IconButton
                  onClick={
                    broken ? () => toggleSidebar() : () => collapseSidebar()
                  }
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>
          {!collapsed && (
            <Box mb="25px">
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                  "& .avater-image": {
                    backgroundColor: colors.primary[500],
                  },
                }}
              >
                <img
                  className="avater-image"
                  alt="profile user"
                  width="72px"
                  height="72px"
                  src={html}
                  style={{ cursor: "pointer" }}
                />
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h3"
                  color={colors.white[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                  style={{ textAlign: 'center' }}
                >
                  <h3 className="text-light">HTML 5</h3>
                </Typography>
              </Box>
            </Box>
          )}
          <Box paddingLeft={collapsed ? undefined : "1%"}>

            {/* Correct MenuItem usage with onClick navigation */}
            <MenuItem 
              active={isActive("/dashboard")}
              style={getActiveStyle("/dashboard")}
              icon={<HomeOutlinedIcon />}
              onClick={() => handleMenuItemClick("/dashboard")}
            >
              Go to Dashboard
            </MenuItem>

            <MenuItem 
              active={isActive("/html-course-outline")}
              style={getActiveStyle("/html-course-outline")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-course-outline")}
            >
              Course outline
            </MenuItem>

            <MenuItem 
              active={isActive("/html-lesson-1")}
              style={getActiveStyle("/html-lesson-1")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-lesson-1")}
            >
              1. What is HTML?
            </MenuItem>

            <MenuItem 
              active={isActive("/create-html")}
              style={getActiveStyle("/create-html")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/create-html")}
            >
              1.1 Create HTML Document
            </MenuItem>

            <MenuItem 
              active={isActive("/html-tags")}
              style={getActiveStyle("/html-tags")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-tags")}
            >
              2. HTML Tags
            </MenuItem>

            <MenuItem 
              active={isActive("/html-paragraphs")}
              style={getActiveStyle("/html-paragraphs")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-paragraphs")}
            >
              3. Paragraphs
            </MenuItem>

            <MenuItem 
              active={isActive("/html-line-break")}
              style={getActiveStyle("/html-line-break")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-line-break")}
            >
              4. Line Breaks
            </MenuItem>

            <MenuItem 
              active={isActive("/html-headings")}
              style={getActiveStyle("/html-headings")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-headings")}
            >
              5. Headings
            </MenuItem>

            <MenuItem 
              active={isActive("/html-view-source-code")}
              style={getActiveStyle("/html-view-source-code")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-view-source-code")}
            >
              6. View Source Code
            </MenuItem>

            <MenuItem 
              active={isActive("/html-comments")}
              style={getActiveStyle("/html-comments")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-comments")}
            >
              7. Comments
            </MenuItem>

            <MenuItem 
              active={isActive("/html-attributes")}
              style={getActiveStyle("/html-attributes")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-attributes")}
            >
              8. Attributes
            </MenuItem>

            <MenuItem 
              active={isActive("/html-id-selectors")}
              style={getActiveStyle("/html-id-selectors")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-id-selectors")}
            >
              9. id Selector
            </MenuItem>

            <MenuItem 
              active={isActive("/html-class-selectors")}
              style={getActiveStyle("/html-class-selectors")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-class-selectors")}
            >
              10. class Selector
            </MenuItem>

            <MenuItem 
              active={isActive("/html-block-inline-elements")}
              style={getActiveStyle("/html-block-inline-elements")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-block-inline-elements")}
            >
              11. Block & Inline Elements
            </MenuItem>

            <MenuItem 
              active={isActive("/html-images")}
              style={getActiveStyle("/html-images")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-images")}
            >
              12. Images
            </MenuItem>

            <MenuItem 
              active={isActive("/html-colors")}
              style={getActiveStyle("/html-colors")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-colors")}
            >
              13. Colors
            </MenuItem>

            <MenuItem 
              active={isActive("/html-links")}
              style={getActiveStyle("/html-links")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-links")}
            >
              14. Links
            </MenuItem>

            <MenuItem 
              active={isActive("/html-quote")}
              style={getActiveStyle("/html-quote")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-quote")}
            >
              15. Quotations
            </MenuItem>

            <MenuItem 
              active={isActive("/html-tables")}
              style={getActiveStyle("/html-tables")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-tables")}
            >
              16. Tables
            </MenuItem>

            <MenuItem 
              active={isActive("/html-lists")}
              style={getActiveStyle("/html-lists")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-lists")}
            >
              17. Lists
            </MenuItem>

            <MenuItem 
              active={isActive("/html-text-format")}
              style={getActiveStyle("/html-text-format")}
              icon={<SchoolOutlinedIcon />}
              onClick={() => handleMenuItemClick("/html-text-format")}
            >
              18. Text Formatting
            </MenuItem>

          </Box>
        </Menu>
      </Sidebar>
    </Box>
  );
};

export default HTMLCourseNav;